module.exports = __webpack_public_path__ + "img/ep-D.ce5dc563.jpg";